module.exports = __webpack_public_path__ + "72f47a8a7412156aa97b09b10245d7bc.png";